import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { NeuButton, NeuCard, NeuInput, NeuSelect } from "../../components/neu/Neu";
import { issueStock, receiveStock } from "../../api/acctIfrs";
import { listBoxes } from "../../api/accounting";
import { useApiError } from "../../hooks/useApiError";

// IAS 2: receipts recompute the weighted average, issues expense it to cost of sales.
export const InvMoveForm = ({ items, onDone }) => {
  const { t } = useTranslation();
  const describe = useApiError();
  const [form, setForm] = useState({ item_id: "", quantity: "", unit_cost: "", cashbox_id: "" });
  const [boxes, setBoxes] = useState([]);

  useEffect(() => {
    listBoxes().then(setBoxes).catch(() => setBoxes([]));
  }, []);

  const run = async (kind) => {
    try {
      const body = {
        item_id: form.item_id || items[0]?.id,
        quantity: Number(form.quantity),
        unit_cost: Number(form.unit_cost || 0),
        cashbox_id: form.cashbox_id || undefined,
      };
      const res = kind === "in" ? await receiveStock(body) : await issueStock(body);
      toast.success(`${t(`acct.ifrs.moveDone.${kind}`)} ${res.entry_number}`);
      setForm({ ...form, quantity: "", unit_cost: "" });
      onDone();
    } catch (error) {
      toast.error(describe(error));
    }
  };

  const set = (key) => (event) => setForm({ ...form, [key]: event.target.value });

  return (
    <NeuCard className="grid gap-3 p-5 sm:grid-cols-6" data-testid="move-form">
      <NeuSelect data-testid="move-item" value={form.item_id} onChange={set("item_id")}>
        <option value="">{t("acct.ifrs.pickItem")}</option>
        {items.map((item) => (
          <option key={item.id} value={item.id}>{item.name}</option>
        ))}
      </NeuSelect>
      <NeuInput data-testid="move-qty" type="number" placeholder={t("acct.ifrs.quantity")} value={form.quantity} onChange={set("quantity")} />
      <NeuInput data-testid="move-cost" type="number" placeholder={t("acct.ifrs.unitCost")} value={form.unit_cost} onChange={set("unit_cost")} />
      <NeuSelect data-testid="move-box" value={form.cashbox_id} onChange={set("cashbox_id")}>
        <option value="">{t("acct.ifrs.onCredit")}</option>
        {boxes.map((box) => (
          <option key={box.id} value={box.id}>{box.name}</option>
        ))}
      </NeuSelect>
      <NeuButton variant="primary" data-testid="move-receive" disabled={!form.quantity} onClick={() => run("in")}>
        {t("acct.ifrs.receive")}
      </NeuButton>
      <NeuButton data-testid="move-issue" disabled={!form.quantity} onClick={() => run("out")}>
        {t("acct.ifrs.issue")}
      </NeuButton>
    </NeuCard>
  );
};
